import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import VueCookies from "vue-cookies";
import VueMeta from "vue-meta";
import store from "./store";
import VueGtag from "vue-gtag";
import * as VueGoogleMaps from "vue2-google-maps";
import device from "vue-device-detector";

Vue.use(VueMeta);

Vue.config.errorHandler = (err, vm, info) => {
  if (
    process.env.VUE_APP_DISABLE_CONSOLE_LOGS !== true ||
    process.env.VUE_APP_DISABLE_CONSOLE_LOGS !== "true"
  ) {
    console.log("Error: ", err, vm.name, info);
  }
};

Vue.config.warnHandler = function (err, vm, info) {
  if (
    process.env.VUE_APP_DISABLE_CONSOLE_LOGS !== true ||
    process.env.VUE_APP_DISABLE_CONSOLE_LOGS !== "true"
  ) {
    console.log("Warn", err, vm.name, info);
  }
};

Vue.use(VueCookies, { expire: "30d" });

if (
  process.env.VUE_APP_ENABLE_GA === true ||
  process.env.VUE_APP_ENABLE_GA === "true"
) {
  Vue.use(
    VueGtag,
    {
      config: { id: "G-M9NH0XS1DF" },
      enabled: false,
    },
    router
  );
}

Vue.use(VueGoogleMaps, {
  load: { key: process.env.VUE_APP_GMAPS_API_KEY, libraries: "places" },
  installComponents: true,
});

Vue.config.productionTip = false;
Vue.config.devtools = false;

Vue.use(device);

const app = new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

if (window.Cypress) {
  // only available during E2E tests
  window.app = app;
}
